import { atom } from "recoil";

export const allSMSTemplatesListState = atom({
  key: "allSMSTemplatesListState",
  default: [],
});
